import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useMemo, useState, useContext, useCallback, useEffect } from "react";
import { useCouponCode } from "../talons/CartPage/PriceAdjustments/useCouponCode";
import { useUserContext } from "./user";
import { useCartContext } from "./cart";
import { useCatalogContext } from "@magento/peregrine/lib/context/catalog";
import { useCheckoutContext } from "@magento/peregrine/lib/context/checkout";
import { castToCorrectType } from "@Src_main/utils/generalUtils";
export var CouponContext = createContext();
export var useCouponContext = () => useContext(CouponContext);
export var CouponProvider = _ref => {
  var {
    children
  } = _ref;
  var [selectedCoupon, setSelectedCoupon] = useState(null);
  var [modalReminderSku, setModalReminderSku] = useState(null);
  var [couponAppliedsuccessfully, setCouponAppliedSuccessfully] = useState(false);
  var [closeTriggerCouponModal, setCloseTriggerCouponModal] = useState(null);
  var [userCoupons, setUserCoupons] = useState([]);
  var [couponLoaded, setCouponLoaded] = useState(false);
  var {
    applyingCoupon,
    appliedCoupon,
    errors,
    handleApplyCoupon,
    handleRemoveCoupon,
    removingCoupon,
    isLoading,
    getAvailableCoupon
  } = useCouponCode();
  var [{
    currentUser,
    isSignedIn,
    isGettingDetails
  }] = useUserContext();
  var [{
    cartId
  }] = useCartContext();
  var [{
    products
  }] = useCatalogContext();
  var [{
    tableData
  }] = useCheckoutContext();
  var setUserCouponWrapper = coupons => {
    var couponsParsed = coupons.map(coupon => {
      var couponTemp = _objectSpread({}, coupon);
      delete couponTemp.additional_data;
      var additionalDataParsed = {};
      var additionalDataValues = Object.values(coupon.additional_data);
      additionalDataValues.forEach(data => {
        if (["MOD_CONDIMENTO", "MOD_TOPPING", "MOD_GRATTU"].includes(data.key)) {
          var parsedValue = data.value.split(",");
          additionalDataParsed[data.key] = parsedValue;
        } else {
          var _parsedValue = castToCorrectType(data.value, data.key);
          additionalDataParsed[data.key] = _parsedValue;
        }
      });
      return _objectSpread(_objectSpread({}, couponTemp), additionalDataParsed);
    });
    setUserCoupons(couponsParsed);
  };
  var updateAvailableCoupon = () => {
    getAvailableCoupon({
      onCompleted: data => {
        var _data$customer, _data$customer$lsAcco;
        if (data !== null && data !== void 0 && (_data$customer = data.customer) !== null && _data$customer !== void 0 && (_data$customer$lsAcco = _data$customer.lsAccount) !== null && _data$customer$lsAcco !== void 0 && _data$customer$lsAcco.coupons) {
          setUserCouponWrapper(data.customer.lsAccount.coupons);
        }
      }
    });
  };
  useEffect(() => {
    var _tableData$store;
    if (tableData !== null && tableData !== void 0 && (_tableData$store = tableData.store) !== null && _tableData$store !== void 0 && _tableData$store.disableCoupon) {
      setUserCoupons([]);
      if (appliedCoupon) {
        handleRemoveCoupon();
      }
    }
  }, [tableData, appliedCoupon]);
  useEffect(() => {
    var _currentUser$lsAccoun;
    if (currentUser !== null && currentUser !== void 0 && (_currentUser$lsAccoun = currentUser.lsAccount) !== null && _currentUser$lsAccoun !== void 0 && _currentUser$lsAccoun.coupons && userCoupons.length === 0) {
      var _currentUser$lsAccoun2;
      setUserCouponWrapper(currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$lsAccoun2 = currentUser.lsAccount) === null || _currentUser$lsAccoun2 === void 0 ? void 0 : _currentUser$lsAccoun2.coupons);
      setCouponLoaded(true);
    } else if (cartId && currentUser.email) {
      updateAvailableCoupon();
    }
  }, [cartId, currentUser.email]);
  var isCouponAvailableForSku = useCallback(sku => {
    if (!userCoupons || userCoupons.length === 0) {
      return false;
    }
    var now = new Date();
    var currentHour = now.getHours();
    var currentMinute = now.getMinutes();
    var currentTimeInMinutes = currentHour * 60 + currentMinute;
    return userCoupons.some(coupon => {
      // Check if SKU matches
      var skuMatches = coupon.items && coupon.items.includes(sku);
      if (!skuMatches) {
        return false;
      }

      // Check time validity
      var isWithinValidTime = true; // Default to true if no valid_time
      if (coupon !== null && coupon !== void 0 && coupon.valid_time) {
        try {
          var [startTimeStr, endTimeStr] = coupon.valid_time.split('-');
          var [startHour, startMinute] = startTimeStr.split(':').map(Number);
          var [endHour, endMinute] = endTimeStr.split(':').map(Number);
          var startTimeInMinutes = startHour * 60 + startMinute;
          var endTimeInMinutes = endHour * 60 + endMinute;

          // Handle overnight validity (e.g., 22:00 - 02:00)
          if (endTimeInMinutes < startTimeInMinutes) {
            isWithinValidTime = currentTimeInMinutes >= startTimeInMinutes || currentTimeInMinutes <= endTimeInMinutes;
          } else {
            isWithinValidTime = currentTimeInMinutes >= startTimeInMinutes && currentTimeInMinutes <= endTimeInMinutes;
          }
        } catch (error) {
          console.error("Error parsing coupon valid_time:", coupon.valid_time, error);
          isWithinValidTime = true; // Treat as valid if parsing fails
        }
      }
      return isWithinValidTime; // Return true only if SKU matches AND time is valid
    });
  }, [userCoupons]);
  var getSkusByBarcode = useCallback(coupon => {
    var couponSku = products.length ? products.find(x => coupon.items.includes(x.sku)) : null;
    return couponSku === null || couponSku === void 0 ? void 0 : couponSku.sku;
  }, [userCoupons, products]);
  var contextValue = {
    applyingCoupon,
    errors,
    handleApplyCoupon,
    handleRemoveCoupon,
    removingCoupon,
    isLoading,
    couponLoaded,
    userCoupons,
    selectedCoupon,
    setSelectedCoupon,
    isCouponAvailableForSku,
    appliedCoupon,
    getSkusByBarcode,
    modalReminderSku,
    setModalReminderSku,
    couponAppliedsuccessfully,
    setCouponAppliedSuccessfully,
    closeTriggerCouponModal,
    setCloseTriggerCouponModal
  };
  return /*#__PURE__*/React.createElement(CouponContext.Provider, {
    value: contextValue
  }, children);
};